import { MARKET_COUNTRY_OPTIONS } from "../onboarding/experience-catalog.mjs";
import { normalizeDailyDefaultEdition } from "./daily-default-edition-audio-contract.mjs";

const PATH = "/api/brief/narration/default-edition";
const SECTIONS = Object.freeze({
  IN: ["news", "news_global_in_world", "market_pulse", "cricket", "news_global_in_technology", "quote"],
  US: ["news", "news_global_us_world", "market_pulse", "sport_nfl", "news_global_us_ai", "quote"],
  CA: ["news", "news_global_ca_world", "sport_hockey", "market_pulse", "quote"],
  GB: ["news", "news_global_gb_world", "sport_football", "market_pulse", "quote"],
  AU: ["news", "news_global_au_world", "sport_afl", "cricket", "market_pulse", "quote"],
  DE: ["news", "news_global_de_world", "news_global_de_business", "market_pulse", "sport_football", "quote"],
  FR: ["news", "news_global_fr_world", "sport_football", "market_pulse", "quote"],
  JP: ["news", "market_pulse", "sport_baseball", "news_global_jp_technology", "quote"],
});
const ZONES = Object.freeze({ IN: "Asia/Kolkata", US: "America/New_York", CA: "America/Toronto", GB: "Europe/London", AU: "Australia/Sydney", DE: "Europe/Berlin", FR: "Europe/Paris", JP: "Asia/Tokyo" });

export function standardBriefPreviewAudioKey(selection) {
  const values = [selection?.countryCode, selection?.languageCode, selection?.profileId, selection?.firstSectionId, ...(selection?.sectionIds || [])];
  return "standard-brief-preview:" + values.map((value) => {
    const text = typeof value === "string" ? value : "";
    return `${text.length}:${text}`;
  }).join("|");
}
export function standardBriefPreviewSelection(input) {
  const countryCode = typeof input?.countryCode === "string" ? input.countryCode.trim().toUpperCase() : "";
  const languageCode = typeof input?.languageCode === "string" ? input.languageCode.trim().toLowerCase() : "";
  const firstSectionId = input?.firstSectionId;
  const market = MARKET_COUNTRY_OPTIONS.find((candidate) => candidate.code === countryCode);
  const ids = input?.sectionIds;
  if (!market || !market.languages.includes(languageCode) || !Array.isArray(ids) || ids.length < 1 || ids.length > 128 ||
    ids.some((id) => typeof id !== "string" || !/^[a-z0-9][a-z0-9_-]{0,95}$/.test(id)) || new Set(ids).size !== ids.length ||
    firstSectionId !== ids[0] || !SECTIONS[countryCode]?.includes(firstSectionId) ||
    typeof input?.profileId !== "string" || !input.profileId.trim() || input.profileId.length > 160) {
    throw new TypeError("standard_brief_preview_unsupported");
  }
  return Object.freeze({ countryCode, languageCode, firstSectionId, profileId: input.profileId, sectionIds: Object.freeze([...ids]) });
}
export function buildStandardBriefPreviewUrl(input) {
  const selection = standardBriefPreviewSelection(input);
  return `${PATH}?${new URLSearchParams({ countryCode: selection.countryCode, languageCode: selection.languageCode, voiceId: "auto", sectionIds: selection.firstSectionId })}`;
}
export function standardBriefPreviewServiceDate(countryCode, httpDate) {
  if (typeof httpDate !== "string" || !/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), \d{2} (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{4} \d{2}:\d{2}:\d{2} GMT$/.test(httpDate)) throw new TypeError("standard_brief_preview_server_date_unavailable");
  const clock = new Date(httpDate);
  if (!Number.isFinite(clock.getTime()) || !ZONES[countryCode]) throw new TypeError("standard_brief_preview_server_date_unavailable");
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: ZONES[countryCode], year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23" }).formatToParts(clock);
  const get = (type) => Number(parts.find((part) => part.type === type)?.value);
  const day = new Date(Date.UTC(get("year"), get("month") - 1, get("day") - (get("hour") < 5 ? 1 : 0)));
  return day.toISOString().slice(0, 10);
}
export function validateStandardBriefPreviewManifest(value, input, httpDate) {
  const selection = standardBriefPreviewSelection(input);
  if (!value || value.countryCode !== selection.countryCode || value.languageCode !== selection.languageCode ||
    value.voiceId !== "auto" || value.dateKey !== standardBriefPreviewServiceDate(selection.countryCode, httpDate) ||
    !Array.isArray(value.items) || value.items.length !== 1 || value.items[0]?.sectionId !== selection.firstSectionId) {
    throw new TypeError("standard_brief_preview_manifest_invalid");
  }
  return normalizeDailyDefaultEdition(value, { ...selection, defaultSectionIds: [selection.firstSectionId] });
}
